function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M47.78 2.72L46.81 0H8L7 2.72A127.49 127.49 0 00.65 28a58.44 58.44 0 000 17.42A28.45 28.45 0 005.2 57.08c4 5.71 11.54 9 19.66 9.75V103H8.78v5.22h38.07V103H30.3V66.78c7.93-.84 15.34-4.08 19.31-9.7a24.51 24.51 0 002.71-5c5.94-14.83-.05-36.76-4.54-49.36zM6.52 18.46a31.55 31.55 0 011-4c1.14-4.22 2.35-7.69 3.31-10.38V4H44c.93 2.6 2.1 6.34 3.2 10.38.65 1.94 1.12 4 1.12 4 .72 3 1.36 6.27 1.81 9.54H4.71c.45-3.19 1.09-6.42 1.81-9.46z",
  fill: "currentColor",
  "data-name": "Layer 1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 54.81 108.22"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/wine-large.svg";
export { SvgComponent as ReactComponent };